import React, { Component } from "react";
import { connect } from "react-redux";
import { listStr } from "../../actions/p2kb/str_action";
import {
  getListStr,
  getStrError,
  getStrPending,
} from "../../reducers/p2kb/str_reducer";
import MaterialTable from "material-table";
import PaginationComponent from "../../components/table/PaginationComponent";
import { Paper } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import DetailButtonComponent from "../../components/global-components/DetailButtonComponent";
import ContentContainer from "../../components/container/ContainerComponent";
import StrHeader from "./StrHeader";
import TableStatusComponent from "../../components/global-components/TableStatusComponent";
import moment from 'moment';
import localization from 'moment/locale/id';

class Str extends Component {
  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
    this.state = {
      id: null,
      search_text: "",
      status: null,
    };

    this.handleRefresh = this.handleRefresh.bind(this);
    this.handleShowModalAdd = this.handleShowModalAdd.bind(this);
    this.detailRecord = this.detailRecord.bind(this);
  }

  onchange(e) {
    this.setState({ input: e.target.value });
  }

  handleRefresh(state) {
    if (state) {
      this.setState(state);
    }
    this.setState({ id: null })
    this.tableRef.current && this.tableRef.current.onQueryChange();
  }

  detailRecord(id) {
    this.props.history.push(`/admin/str/detail/${id}`);
  }

  handleShowModalAdd() {
    this.setState({ showModalAdd: true });
  }

  componentDidMount() {
    const id = this.props.match.params.id;
    if (id && this.state.id === null) {
      this.setState({ id: id })
    }
  }

  render() {
    const { listStr, listStr_data } = this.props;
    const { search_text } = this.state;
    let data = [];
    let records_total = 0;
    if (listStr_data) {
      data = listStr_data.data;
      records_total = listStr_data.records_total;
    }
    return (
      <ContentContainer>
        <StrHeader
          handleRefresh={this.handleRefresh}
          handleShowModalAdd={this.handleShowModalAdd}
        />
        <MaterialTable
          tableRef={this.tableRef}
          columns={[
            {
              title: "No",
              field: "no",
              headerStyle: {
                paddingLeft: 40,
              },
              cellStyle: {
                paddingLeft: 40,
              },
            },
            {
              title: "Member",
              field: "user_data.name",
            },
            {
              title: "Nomor STR",
              field: "str_no",
            },
            {
              title: "Tanggal Penetapan",
              render: ({ start_date }) => {
                return moment(start_date).locale('id', localization).format('DD MMMM YYYY')
              }
            },
            {
              title: "Tanggal Berakhir",
              render: ({ end_date }) => {
                return moment(end_date).locale('id', localization).format('DD MMMM YYYY')
              }
            },
            {
              title: "User",
              headerStyle: {
                minWidth: 140,
              },
              field: "role_next_approve",
              render: ({ role_next_approve }) =>
                role_next_approve ? role_next_approve.role_name : "Admin PABOI Cabang",
            },
            {
              title: "Status",
              field: "status",
              render: ({ status }) => {
                return (
                  <TableStatusComponent
                    status={
                      status === 0
                        ? "Baru"
                        : status === 1
                          ? "Terverifikasi"
                          : "Ditolak"
                    }
                  />
                );
              },
            },
            {
              title: "",
              render: ({ id }) => (
                <DetailButtonComponent>
                  <MenuItem onClick={() => this.detailRecord(id)}>
                    Detail
                  </MenuItem>
                </DetailButtonComponent>
              ),
            },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let param = {
                page: query.page + 1,
                length: 10,
                search_text: search_text,
                id: this.state.id,
                status: this.state.status
              };
              listStr(param, resolve, reject);
            })
          }
          options={{
            pageSize: 10,
            paginationType: "stepped",
            pageSizeOptions: [],
            headerStyle: {
              backgroundColor: "#F8F9FB",
            },
          }}
          localization={{
            body: {
              emptyDataSourceMessage: "Tidak ada data",
            },
          }}
          components={{
            Toolbar: () => <div />,
            Container: (props) => <Paper {...props} elevation={0} />,
            Pagination: (props) => (
              <PaginationComponent
                records={data.length}
                records_total={records_total}
                {...props}
              />
            ),
          }}
        />
      </ContentContainer>
    );
  }
}

function mapStateToProps({ listStr }) {
  return {
    listStr_data: getListStr(listStr),
    listStr_error: getStrError(listStr),
    listStr_pending: getStrPending(listStr),
  };
}

export default connect(mapStateToProps, {
  listStr,
})(Str);
